module.exports = __webpack_public_path__ + "assets/fe4bd18a5bcfd6b2c11fc3e592517e20.png";